var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.32 23.32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M16.667 14.667h-1.054l-.373-.36a8.68 8.68 0 10-.933.933l.36.373v1.053l6.667 6.653 1.987-1.987zm-8 0a6 6 0 116-6 5.992 5.992 0 01-6 6z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "de40c18cc16a3c1ca2f7e800c9bfc81e.svg";
export { SvgSearchWhite as ReactComponent };